import { createSelector } from 'reselect';
import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import MODULE_NAME from '../constants/moduleName';

const getModuleStateSelector = createModuleStateSelector(MODULE_NAME);

export const getIguazuResourcesSelector = createSelector(
  getModuleStateSelector,
  (state) => state.get('resources')
);

export default getModuleStateSelector;
